import { constants } from "../constants/redux-constants";

const initialState = {
  adminDashboard: {
    isVisible: false,
    isDisabled: false,
  },
  patientDashboard: {
    isVisible: false,
    isDisabled: false,
  },
  renderer: 1,
};

const quickAccessReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.QUICK_ACCESS.ADMIN_DASHBOARD.SET_IS_VISIBLE:
      return {
        ...state,
        adminDashboard: {
          ...state.adminDashboard,
          isVisible: action.payload,
        },
      };
    case constants.QUICK_ACCESS.ADMIN_DASHBOARD.SET_IS_DISABLED:
      return {
        ...state,
        // value: state.value + 1,
        adminDashboard: {
          ...state.adminDashboard,
          isDisabled: action.payload,
        },
      };
    case constants.QUICK_ACCESS.PATIENT_DASHBOARD.SET_IS_VISIBLE:
      return {
        ...state,
        patientDashboard: {
          ...state.patientDashboard,
          isVisible: action.payload,
        },
      };
    case constants.QUICK_ACCESS.PATIENT_DASHBOARD.SET_IS_DISABLED:
      return {
        ...state,
        // value: state.value + 1,
        patientDashboard: {
          ...state.patientDashboard,
          isDisabled: action.payload,
        },
      };
    case constants.QUICK_ACCESS.RESET:
      return initialState;
    case constants.QUICK_ACCESS.CLOSE_OVERLAY:
      return {
        ...state,
        renderer: state?.renderer + 1,
      };
    default:
      return state;
  }
};

export default quickAccessReducer;
